module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/4_8a9153aed180b29c58c38a8fa2d44a52.png";